import React from 'react';
import { plannedSection } from '../data/copy';
import { OFFER_ANCHOR } from './constants';
export function PlannedSection() {
  return <section className="border-y border-pf-creamDark bg-white px-3 py-3 sm:px-4 sm:py-4" data-id="element-152" data-mp="bicjfzi09tnv">
      <div className="mx-auto max-w-4xl text-center" data-id="element-153" data-mp="gg49enz3b5pf">
        <h2 className="mb-1 font-display text-xl font-extrabold uppercase leading-tight tracking-tight sm:text-4xl" data-id="element-154" data-mp="ki95dtd0gef8">
          {plannedSection.title}
        </h2>
        <div className="mx-auto max-w-3xl space-y-0.5 text-[12.5px] font-medium leading-snug text-pf-ink sm:text-base" data-id="element-155" data-mp="phc12n73p8aj">
          {plannedSection.lines.map(line => <p key={line} data-id="element-156" data-mp="z8q434y9gq8f">{line}</p>)}
        </div>
        <p className="mb-1.5 mt-0.5 font-display text-[14px] font-extrabold uppercase text-pf-coral sm:text-xl" data-id="element-157" data-mp="1468gj5bhlnl6">
          {plannedSection.needLine}
        </p>

        <ul className="mx-auto mb-1.5 flex max-w-3xl flex-wrap items-center justify-center gap-1" data-id="element-158" data-mp="189wm5igk693s">
          {plannedSection.pillars.map(pillar => <li key={pillar} data-id="element-159" data-mp="bw717qughsy2">
              <a href={OFFER_ANCHOR} className="block rounded border border-pf-navy/15 bg-pf-cream px-2 py-1 font-display text-[11px] font-bold uppercase tracking-wide text-pf-navy transition-colors duration-150 ease-out hover:border-pf-coral sm:text-[13px]" data-id="element-160" data-mp="bxi5drrtd2pp">
                {pillar}
              </a>
            </li>)}
        </ul>

        <p className="mx-auto max-w-3xl text-[12.5px] font-semibold leading-snug text-pf-navy sm:text-base" data-id="element-161" data-mp="viml6h5qn6ng">
          {plannedSection.close}
        </p>
      </div>
    </section>;
}